export default __webpack_public_path__ + "static/media/flyers.1e8c32af.png";